export default "__VITE_ASSET__DziQDt4Z__"